import {FC, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import axiosInstance from './api/axiosInstance'
import Swal from 'sweetalert2'

const PegadaianSearchBooking: FC = () => {
  const navigate = useNavigate()
  const [nikSearch, setNikSearch] = useState('')
  const [showResult, setShowResult] = useState(false)
  const [bookingData, setBookingData] = useState<any[] | null>(null)
  const [loading, setLoading] = useState(false)

  const handleCheck = async () => {
    if (nikSearch.length < 16) {
      await Swal.fire({
        icon: 'warning',
        title: 'NIK Tidak Valid',
        text: 'Silakan masukkan 16 digit NIK.',
        confirmButtonColor: '#72BF44',
      })
      return
    }

    setLoading(true)

    try {
      const response = await axiosInstance.get(
        `/rsvm/api/rsvm-booking/v1/search-by-nik?nik=${nikSearch}`
      )

      const result = response?.data?.data

      if (result && result.length > 0) {
        setBookingData(result)
        setShowResult(true)

        await Swal.fire({
          icon: 'success',
          title: 'Data Ditemukan',
          text: 'Data booking berhasil ditemukan.',
          confirmButtonColor: '#72BF44',
        })
      } else {
        setShowResult(false)
        setBookingData(null)

        await Swal.fire({
          icon: 'info',
          title: 'Tidak Ditemukan',
          text: 'Data booking tidak ditemukan untuk NIK ini.',
          confirmButtonColor: '#72BF44',
        })
      }
    } catch (error: any) {
      const message = error?.response?.data?.message || 'Terjadi kesalahan saat mengambil data.'

      await Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: message,
        confirmButtonColor: '#72BF44',
      })
    } finally {
      setLoading(false)
    }
  }

  const hendleBack = () => {
    navigate('/mudik-bersama/pegadaian/reservasi')
  }

  return (
    <div className='container-xxl p-0' style={{minHeight: '100vh'}}>
      <div className='row justify-content-center mx-0'>
        <div
          className='col-12 col-md-8 col-lg-5 p-0 bg-white pb-md-10 pb-8 mx-auto'
          style={{position: 'relative'}}
        >
          <div className='position-relative w-100 overflow-hidden'>
            {/* Background */}
            <img
              src={toAbsoluteUrl('/img/pegadaian-bg.png')}
              alt='Background'
              className='w-100 d-block'
              style={{
                height: 'clamp(100px, 14vw, 130px)',
                objectFit: 'cover',
              }}
            />

            <div className='position-absolute top-50 start-0 w-100 translate-middle-y px-5'>
              <div className='d-flex align-items-center justify-content-between'>
                {/* Back Button */}
                <button onClick={hendleBack} className='btn p-0'>
                  <i className='bi bi-x-lg fs-2 text-white'></i>
                </button>

                {/* Title */}
                <div className='ms-auto text-end'>
                  <h2 className='fw-bolder mb-0 fs-3 fs-md-2 fs-lg-1 text-white'>Check Booking</h2>
                </div>
              </div>
            </div>
          </div>
          <div className='position-relative z-index-2'>
            <div
              className='alert alert-warning shadow-sm mb-0'
              style={{
                backgroundColor: '#FFF4D6',
                border: 'none',
                padding: 'clamp(12px, 4vw, 20px)',
              }}
            >
              <div className='d-flex align-items-center justify-content-between w-100'>
                {/* Kiri: Logo */}
                <img
                  src={toAbsoluteUrl('/img/pegadaian-logo-bl.png')}
                  alt='pegadaian'
                  style={{
                    height: 'clamp(24px, 6vw, 44px)',
                    objectFit: 'contain',
                  }}
                />

                {/* Kanan: Title */}
                <h2 className='fw-bolder mb-0 fs-4 fs-md-3 fs-lg-2 text-end'>
                  <span style={{color: '#72BF44'}}>Mudik</span>{' '}
                  <span style={{color: '#BFD730'}}>Bersama</span>
                </h2>
              </div>
            </div>
          </div>

          <div className='px-5 mt-8'>
            <div className='position-relative mb-5'>
              <i className='bi bi-search position-absolute top-50 start-0 translate-middle-y ms-4 text-primary fs-3'></i>
              <input
                type='text'
                className='form-control form-control-solid ps-12 p-4 border-0 bg-light'
                placeholder='Input NIK'
                style={{borderRadius: '12px'}}
                value={nikSearch}
                onChange={(e) => {
                  setNikSearch(e.target.value)
                  if (e.target.value === '') setShowResult(false)
                }}
              />
            </div>
            <button
              onClick={handleCheck}
              className='btn btn-success w-100 py-4 fw-bold shadow-sm'
              style={{borderRadius: '40px'}}
            >
              Check Status
            </button>
          </div>

          <div className='px-5 mt-10'>
            {!showResult ? (
              /* EMPTY STATE: Card Gray */
              <div
                className='d-flex flex-column align-items-center justify-content-center p-10 text-center'
                style={{
                  backgroundColor: '#F9F9F9',
                  borderRadius: '20px',
                  border: '2px dotted #E4E6EF',
                  minHeight: '200px',
                }}
              >
                <div className='bg-white rounded-circle p-4 mb-4 shadow-sm'>
                  <i className='bi bi-ticket-perforated text-muted fs-1'></i>
                </div>
                <h5 className='text-muted fw-bold'>Belum ada data ditampilkan</h5>
                <p className='text-muted small'>
                  Masukkan NIK Anda untuk mengecek status pemesanan tiket mudik.
                </p>
              </div>
            ) : (
              /* Mapping data dari API */
              bookingData?.map((item, idx) => {
                const isConfirmed = item.statusBooking === 'CONFIRMED'
                const isBoarded = item.statusBooking === 'BOARDED'
                const isRejected = item.statusBooking === 'REJECTED'
                const isPending =
                  item.statusBooking === 'PENDING' || item.statusBooking === 'WAITING'

                // Syarat akses masuk ke detail
                const canAccessDetail = isConfirmed || isBoarded

                return (
                  <div
                    key={idx}
                    className={`card border-0 shadow-sm overflow-hidden mb-5 ${
                      canAccessDetail ? 'cursor-pointer' : ''
                    }`}
                    style={{
                      borderRadius: '20px',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      border: '1px solid #f0f0f0',
                      backgroundColor: '#fff',
                      // Efek hover sederhana jika bisa diklik
                      transform: canAccessDetail ? 'scale(1)' : 'none',
                    }}
                    onClick={async () => {
                      if (canAccessDetail) {
                        navigate(
                          `/mudik-bersama/pegadaian/detail-booking?kode_reservasi=${item.code}`
                        )
                      } else if (isRejected) {
                        await Swal.fire({
                          icon: 'error',
                          title: 'Booking Ditolak',
                          text: 'Mohon maaf, permohonan Anda tidak dapat kami setujui. Silakan hubungi admin.',
                          confirmButtonColor: '#F1416C',
                        })
                      } else {
                        await Swal.fire({
                          icon: 'info',
                          title: 'Mohon Menunggu',
                          text: 'Pendaftaran Anda sedang dalam proses verifikasi oleh tim kami.',
                          confirmButtonColor: '#72BF44',
                        })
                      }
                    }}
                  >
                    {/* Header Tiket - Warna berubah sesuai status */}
                    <div
                      className='p-4 text-white d-flex justify-content-between align-items-center'
                      style={{
                        backgroundColor: isConfirmed
                          ? '#72BF44' // Hijau
                          : isBoarded
                          ? '#009EF7' // Biru
                          : isRejected
                          ? '#F1416C' // Merah
                          : '#A1A5B7', // Abu-abu
                      }}
                    >
                      <div>
                        <h4 className='fw-bolder mb-0 text-white'>
                          {item.code.split('-')[0]} - {item.code.substring(item.code.length - 6)}
                        </h4>
                        <span className='small opacity-75' style={{fontSize: '11px'}}>
                          PEGADAIAN {item.origin}
                        </span>
                      </div>
                      {/* Ikon penanda status di header */}
                      <i
                        className={`bi ${
                          isBoarded
                            ? 'bi-patch-check-fill'
                            : isConfirmed
                            ? 'bi-ticket-perforated-fill'
                            : isRejected
                            ? 'bi-x-circle-fill'
                            : 'bi-clock-history'
                        } fs-1`}
                      ></i>
                    </div>

                    <div className='card-body p-6'>
                      {/* Rute Perjalanan */}
                      <div className='d-flex justify-content-between align-items-center mb-6 px-2'>
                        <div className='text-start'>
                          <div className='text-muted' style={{fontSize: '10px'}}>
                            Kota Asal
                          </div>
                          <div className='fw-bolder fs-5 text-uppercase'>{item.origin}</div>
                        </div>

                        <div className='flex-grow-1 mx-4 position-relative text-center'>
                          <div
                            style={{
                              borderBottom: `2px dashed ${
                                isConfirmed ? '#72BF44' : isBoarded ? '#009EF7' : '#E4E6EF'
                              }`,
                              width: '100%',
                            }}
                          ></div>
                          <i
                            className='bi bi-bus-front text-muted position-absolute start-50 top-50 translate-middle bg-white px-2'
                            style={{fontSize: '14px'}}
                          ></i>
                        </div>

                        <div className='text-end'>
                          <div className='text-muted' style={{fontSize: '10px'}}>
                            Kota Tujuan
                          </div>
                          <div className='fw-bolder fs-5 text-uppercase'>{item.destination}</div>
                        </div>
                      </div>

                      <div className='separator separator-dashed my-5'></div>

                      {/* Info Detail Penumpang */}
                      <div className='d-flex flex-column gap-3'>
                        <div className='d-flex justify-content-between align-items-center'>
                          <span className='text-muted small'>Status :</span>
                          <span
                            className={`badge ${
                              isConfirmed
                                ? 'badge-light-success text-success'
                                : isBoarded
                                ? 'badge-light-primary text-primary'
                                : isRejected
                                ? 'badge-light-danger text-danger'
                                : 'badge-light-dark'
                            } fw-bolder px-3 py-2`}
                          >
                            {item.statusBooking}
                          </span>
                        </div>

                        <div className='d-flex justify-content-between'>
                          <span className='text-muted small'>Nama Pendaftar :</span>
                          <span className='fw-bold text-dark'>{item.nama}</span>
                        </div>

                        <div className='d-flex justify-content-between'>
                          <span className='text-muted small'>Tanggal Booking :</span>
                          <span className='fw-bold text-dark'>{item.createdAt.split(' ')[0]}</span>
                        </div>
                      </div>

                      {/* Notifikasi / Hint untuk klik */}
                      {canAccessDetail && (
                        <div className='mt-5 pt-4 border-top text-center'>
                          <span className='text-primary fw-bold small'>
                            Klik untuk melihat detail & e-ticket{' '}
                            <i className='bi bi-chevron-right ms-1'></i>
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )
              })
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PegadaianSearchBooking